import * as React from 'react';
import { Box } from '@mui/material';
import styles from "./tab.module.css"
import { TabComponentProps } from './types';
import { a11yProps, TabPanel } from './components/TabPanel';
import { StyledTabs as Tabs, StyledTab as Tab } from './components/Tabs'

function TabComponent(props: TabComponentProps) {
    const { tabs } = props;
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <div className={styles.tabContainer}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    {tabs?.map((tab, index) => <Tab key={index} label={tab?.label} icon={tab?.icon}  {...a11yProps(index)} />)}
                </Tabs>
            </Box>
            {tabs?.map((tab, index) => <TabPanel key={index} value={value} index={index}>{tab?.component}</TabPanel>)}
        </div>
    );
}

export { TabComponent }; 